<!-- begin::Menu toggle -->
<div
  class="btn btn-icon"
  [ngClass]="toggleBtnClass"
  data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
  data-kt-menu-attach="parent"
  data-kt-menu-placement="bottom-end"
  >
  @if (lang) {
    @if (lang === 'en') {
      <p
        class="theme-light-hide mb-0 menu-item header-menu-item"
        [ngClass]="toggleBtnIconClass"
        >
        EN
      </p>
    }
    @if (lang === 'th') {
      <p class="theme-dark-hide mb-0 gray-700" [ngClass]="toggleBtnIconClass">
        TH
      </p>
    }
  }
</div>
<!-- end::Menu toggle -->

<!-- begin::Menu -->
<div
  class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px"
  data-kt-menu="true"
  >
  <ng-container>
    <div class="menu-item px-3 my-0">
      <a
        class="menu-link px-3 py-2"
        [ngClass]="{ active: lang === 'en' }"
        (click)="switchLang('en')"
        >
        <span class="menu-title">EN</span>
      </a>
    </div>
    <div class="menu-item px-3 my-0">
      <a
        class="menu-link px-3 py-2"
        [ngClass]="{ active: lang === 'th' }"
        (click)="switchLang('th')"
        >
        <span class="menu-title">TH</span>
      </a>
    </div>
  </ng-container>
</div>
<!-- end::Menu -->
